import AuditTrailResults from './AuditTrailResults';

export default AuditTrailResults;
